import React from "react";
import { Flex } from "rebass/styled-components";
import styled from "styled-components";
import { Headline, Title2 } from "../text";
import { LoadingSkeleton } from "../../MVVM/Components/Skeloton";
import { useTranslation } from "react-i18next";

const FollowWrapper = styled(Flex)`
  &:hover {
    cursor: pointer;
  }
`;

export const FollowStats = ({
  loading,
  followers,
  setFollowModalOpen,
  following,
}) => {
  const { t } = useTranslation(`translation`, {
    keyPrefix: "profile.userStats",
  });
  if (loading) {
    return (
      <Flex mt={2} alignItems="center">
        <FollowWrapper>
          <Headline mr={2} color="white">
            <LoadingSkeleton width={200} height={20} />
          </Headline>
        </FollowWrapper>
      </Flex>
    );
  }

  return (
    <Flex mt={2} alignItems="center">
      <FollowWrapper
        onClick={() => {
          setFollowModalOpen("followers");
        }}
      >
        <Headline mr={2} color="white">
          {followers}
        </Headline>
        <Headline mx={2} color="chalk">
          {t("followers")}
        </Headline>
      </FollowWrapper>

      <Title2 mx={2} color="chalk">
        {" "}
        |{" "}
      </Title2>
      <FollowWrapper
        onClick={() => {
          setFollowModalOpen("following");
        }}
      >
        {" "}
        <Headline mx={2} color="white">
          {following}
        </Headline>
        <Headline mx={2} color="chalk">
          {t("following")}
        </Headline>
      </FollowWrapper>
    </Flex>
  );
};
